<template>
  <div class="add-contract-temp">
    <QS-scroller-box>
      <QS-h3-title>
        <template slot="title">
          {{ pageTitle }}
        </template>
      </QS-h3-title>
      <div class="splitline mt16 mb16" />
      <div class="temp_content">
        <div class="temp_content_header">
          <div class="form-box">
            <el-tabs v-model="activeTab" type="card"
            v-if="this.moduleName === contractTemplateModule.entrustWithholdContractTemplate">
              <el-tab-pane name="1">
                <span slot="label">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="合同条款区可支持用户根据公司法务要求进行条款内容及样式修改！"
                    placement="top-end"
                  >
                    <i class="QS-icon-info"></i>
                  </el-tooltip>合同条款区域</span>
                <el-form inline>
                  <el-form-item label="合同模板名称:" required>
                    <el-input
                      v-model="contractName"
                      placeholder="请输入"
                      clearable
                    />
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="扣款方案配置区" name="2">
                <span slot="label">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="扣款方案配置区为固定模板内容不可修改，此处内容会根据扣款方案自动生成，若有疑问请联系平台工作人员！"
                    placement="top-end"
                  >
                    <i class="QS-icon-info"></i>
                  </el-tooltip> 扣款方案配置区</span>
              </el-tab-pane>
            </el-tabs>
            <el-form inline v-else>
                  <el-form-item label="合同模板名称:" required>
                    <el-input
                      v-model="contractName"
                      placeholder="请输入"
                      clearable
                    />
                  </el-form-item>
                </el-form>
          </div>
        </div>
        <div class="editor-container" >
          <div class="edit"><TinymceVue :options="tinymceOptions"/></div>
          <section class="editor-box" v-if="isShowRightOption">
            <div class="editor-box-header">
              选取系统字段 <span>点击字段添加到编辑区光标处</span>
            </div>
            <el-collapse v-model="checkItems">
              <el-collapse-item
                v-for="(item, index) in keywords"
                :key="item.title"
                :title="item.title"
                :name="item.title"
              >
                <div class="box">
                  <div
                    v-for="(item, ind) in item.children"
                    :key="item.name"
                    class="check-item"
                  >
                    <span @click="handleClickSystemVar(index, ind)">
                      ${ {{ item.name }} }
                      <el-tooltip
                        v-if="item.explain"
                        class="item"
                        effect="dark"
                        :content="item.explain"
                        placement="top-end"
                      >
                        <i class="QS-icon-info"></i>
                      </el-tooltip>
                    </span>
                    <span v-if="item.type === 'string'">{{ item.example }}</span>
                    <img v-if="item.type === 'list'" :src='exmUrl'/>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </section>
        </div>
      </div>

      <template slot="bottomAction">
        <div>
          <el-button size="small" @click="pageGoBack">取消</el-button>
          <el-button
            v-if="isPermissionAdd"
            :loading="oLoading.add"
            @click="handleSubmit"
            size="small"
            type="primary"
          >确认新增</el-button>
          <el-button
            v-if="isEdit"
            :loading="oLoading.edit"
            @click="handleSubmit"
            size="small"
            type="primary"
          >提交保存</el-button>
        </div>
      </template>
    </QS-scroller-box>
  </div>
</template>
<script>
import {
  contractTmpAdd,
  contractTmpEdit,
  contractTmpVariables,
  contractTmpPreview,
  contractTmpFixedContentApi,
} from '@/api/domain/carsService'
import { contractTemplateModule } from '@/store/dict/withholdDict'
import TinymceVue from '@/components/TinymceVue/index.vue'
import {
  TinymcevueOptions,
  titleMap,
  GROUP_CONTRACT_TEMPLATE_CREATE,
  GROUP_CONTRACT_TEMPLATE_PREVIEW,
  exmUrl,
  storageKeyAdd,
  storageTitleKeyAdd,
  storageKeyEdit,
  storageTitleKeyEdit,
} from '../config.js'
import { throttle } from 'lodash'
import { getLocalStorage, setLocalStorage } from '@/utils/cache'


import '@/utils/tinymce/tinymce.js'
import '@/utils/tinymce/themes/silver/theme.js'
import '@/utils/tinymce/langs/zh_CN.js'
import '@/utils/tinymce/icons/default/icons.js'
import '@/utils/tinymce/plugins/preview/plugin.js'
import '@/utils/tinymce/plugins/searchreplace/plugin.js'
import '@/utils/tinymce/plugins/autolink/plugin.js'
import '@/utils/tinymce/plugins/fullscreen/plugin.js'
import '@/utils/tinymce/plugins/image/plugin.js'
import '@/utils/tinymce/plugins/link/plugin.js'
import '@/utils/tinymce/plugins/media/plugin.js'
import '@/utils/tinymce/plugins/code/plugin.js'
import '@/utils/tinymce/plugins/codesample/plugin.js'
import '@/utils/tinymce/plugins/charmap/plugin.js'
import '@/utils/tinymce/plugins/pagebreak/plugin.js'
import '@/utils/tinymce/plugins/nonbreaking/plugin.js'
import '@/utils/tinymce/plugins/anchor/plugin.js'
import '@/utils/tinymce/plugins/advlist/plugin.js'
import '@/utils/tinymce/plugins/lists/plugin.js'
import '@/utils/tinymce/plugins/help/plugin.js'
import '@/utils/tinymce/plugins/emoticons/plugin.js'
import '@/utils/tinymce/plugins/autosave/plugin.js'
import '@/utils/tinymce/plugins/quickbars/plugin.js'
import '@/utils/tinymce/plugins/wordcount/plugin.js'
import '@/utils/tinymce/plugins/autoresize/plugin.js'
import '@/utils/tinymce/plugins/emoticons/js/emojis.js'
import '@/utils/tinymce/plugins/table/plugin.js'
import '@/utils/tinymce/plugins/importword/plugin.js'
import '@/utils/tinymce/plugins/imagetools/plugin.js'
import '@/utils/tinymce/plugins/paste/plugin.js'

/**
 * 两个场景会进入当前组件关联的 edit/add
 * 1. sceneType = 0;  /tenantNew/contractTemplate/list 合同模版管理列表页面
 * 1. sceneType = 1;  /car_to_lease/leaseScheme/add?type=1 待租-》租赁配置-》租赁方案管理-》新建方案-》快速创建合同模版
 */

export default {
  name: 'addContractTemp',
  components: {
    TinymceVue,
  },
  props: {
    turnalFlag: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      contractTemplateModule,
      exmUrl,
      checkItems: [], // 默认展开 系统字段
      oLoading: {
        add: false,
        edit: false,
      },
      contractName: '',
      id: '',
      checkKey: null,
      contractContent: '',
      sendContractContent: '', // 最终接口发送的数据
      keywords: [],
      activeTab: '1',
      isReq: false, // 如果是委托代扣 是否是一次请求详情接口
      storageKeyAdd,
      storageTitleKeyAdd,
      storageKeyEdit,
      storageTitleKeyEdit,
    }
  },
  watch: {
    activeTab(v) {
      if (Number(v) === 2) {
        this.sendContractContent = window.tinyMCE.activeEditor.getContent()
      }
      this.contractContent = ''
      this.$nextTick(() => {
        window.tinymce.activeEditor.setContent('')
      })
      if (Number(v) === 1) {
        this.$nextTick(() => {
          window.tinymce.activeEditor.setMode('design')
        })
        if (this.isReq) {
          this.contractContent = this.sendContractContent
          this.$nextTick(() => {
            window.tinymce.activeEditor.execCommand(
              'mceInsertContent',
              false,
              this.contractContent,
            )
          })
        } else {
          this.contractTmpPreview()
        }
      } else {
        this.$nextTick(() => {
          window.tinymce.activeEditor.setMode('readonly')
        })
        this.contractTmpFixedContent()
      }
    },
    contractName(v) {
      setLocalStorage(this.isEdit ? storageTitleKeyEdit : storageTitleKeyAdd, v)
    },
  },
  computed: {
    tinymceOptions() {
      const _TinymcevueOptions = { ...TinymcevueOptions }
      const savedContent = getLocalStorage(this.isEdit ? this.storageKeyEdit : this.storageKeyAdd)
      const savedTitleName = getLocalStorage(
        this.isEdit ? this.storageTitleKeyEdit : this.storageTitleKeyAdd,
      )

      if (this.isEdit || this.isCopy) {
        _TinymcevueOptions.init_instance_callback = () => {
          this.id = parseInt(this.$route.query.id, 10)
          if (!savedContent && !savedTitleName) {
            this.contractTmpPreview()
          } else {
            this.getDraftContent(savedContent, savedTitleName)
          }
        }
      }
      return _TinymcevueOptions
    },
    isPermissionAdd() {
      const status = this.judgePermission(GROUP_CONTRACT_TEMPLATE_CREATE)
      return (this.isAdd || this.isCopy) && status
    },
    isAdd() {
      return this.turnalFlag === 'add'
    },
    isEdit() {
      return this.turnalFlag === 'edit'
    },
    isCopy() {
      return this.turnalFlag === 'add' && this.$route.query.isCopy
    },
    pageTitle() {
      return titleMap.get(this.turnalFlag)
    },
    isShowRightOption() {
      if (this.moduleName) {
        if (this.activeTab === '2' && this.moduleName === contractTemplateModule.entrustWithholdContractTemplate) {
          return false
        }
      }
      return true
    },
  },
  async created() {
    const { moduleName } = this.$route.query
    this.moduleName = moduleName
    // 获取系统模版
    await this.selectVar()
  },
  methods: {
    contractTmpFixedContent() {
      contractTmpFixedContentApi({ bizType: 2 }).then((res) => {
        if (res) {
          const { code, data } = res
          if (code === 1) {
            if (Array.isArray(data)) {
              let content = ''
              data.forEach((item) => {
                content += item.contractContent
              })

              this.contractContent = content
              this.$nextTick(() => {
                window.tinymce?.activeEditor?.execCommand(
                  'mceInsertContent',
                  false,
                  this.contractContent,
                )
              })
            }
          }
        }
      })
    },
    // 提取提交事件
    handleSubmit: throttle(async function () {
      if (!this.getFormValidate()) return
      const params = {
        name: this.contractName,
        contractContent: this.sendContractContent,
      }
      // 如果是编辑需要新增些数据
      if (this.isEdit) {
        params.id = this.id ? this.id : Number(this.$route.query.id)
        params.dimension =
          this.$route.name === GROUP_CONTRACT_TEMPLATE_PREVIEW ? 1 : 2
      }

      if (this.moduleName &&
      this.moduleName === contractTemplateModule.entrustWithholdContractTemplate) {
        params.bizType = 2
      }

      this.oLoading[this.turnalFlag] = true
      const ajaxAction = this.isAdd || this.isCopy ? contractTmpAdd : contractTmpEdit
      const { code, data } = await ajaxAction(params)
      if (code === 1) {
        this.$message.success(
          this.isAdd || this.isCopy ? '操作成功' : '修改成功',
        )
        this.$emit('submitSuccess', data)
        this.pageGoBack(true)
      }
      this.oLoading[this.turnalFlag] = false
    }, 3000, { trailing: false }),
    // 获取表单验证效果
    getFormValidate() {
      this.contractContent = window.tinyMCE.activeEditor.getContent()
      if (this.activeTab === '1') {
        this.sendContractContent = window.tinyMCE.activeEditor.getContent()
      }
      if (!this.contractName.trim()) {
        this.$message.error('模板名称不能为空')
        return false
      }

      if (!this.contractContent.trim() || !this.sendContractContent.trim()) {
        this.$message.error('模板内容不能为空')
        return false
      }
      return true
    },
    // 请求详情接口
    async contractTmpPreview() {
      if (this.moduleName === contractTemplateModule.entrustWithholdContractTemplate) {
        this.isReq = true
      }
      if (!this.id) return
      const params = {
        id: this.id,
      }

      if (this.moduleName &&
      this.moduleName === contractTemplateModule.entrustWithholdContractTemplate) {
        params.bizType = 2
      }
      const { code, data } = await contractTmpPreview(params)
      if (code === 1) {
        window.tinymce.activeEditor.execCommand('mceCleanup')
        this.contractName = data.name
        // 解析模版渲染 table数据
        this.contractContent = data.contractContent
        this.sendContractContent = data.contractContent
        this.$nextTick(() => {
          window.tinymce.activeEditor.execCommand(
            'mceInsertContent',
            false,
            this.contractContent,
          )
        })
      }
    },

    // 获取草稿
    getDraftContent(savedContent, savedTitleName) {
      window.tinymce.activeEditor.execCommand('mceCleanup')
      try {
        this.contractContent = savedContent
        this.sendContractContent = savedContent
        this.contractName = savedTitleName || ''
        this.$nextTick(() => {
          if (window.tinymce && window.tinymce.activeEditor) {
            window.tinymce.activeEditor.execCommand(
              'mceInsertContent',
              false,
              savedContent,
            )
          }
        })
      } catch (error) {
        console.warn('从本地存储恢复内容失败:', error)
      }
    },

    // 合同模板动态字段查询接口
    async selectVar() {
      const params = {}
      if (this.moduleName &&
          this.moduleName === contractTemplateModule.entrustWithholdContractTemplate) {
        params.bizType = 2
      }
      const { code, data } = await contractTmpVariables(params)
      if (code === 1) {
        this.keywords = data
        this.checkItems = data.map((item) => item.title)
      }
    },
    async confirmSelect() {
      if (!this.checkKey) {
        this.$message.error('请先选取对应的key')
        return false
      }
      const [index, ind] = this.checkKey
      const item =
        this.keywords[index] &&
        this.keywords[index].children &&
        this.keywords[index].children[ind]
      const key = item && item.name

      // 插入系统字段
      window.tinymce.activeEditor.execCommand(
        'mceInsertContent',
        false,
        `\${${key}}`,
      )
    },
    // 点击参数变量
    handleClickSystemVar(index, ind) {
      this.checkKey = [index, ind]
      this.confirmSelect()
    },
    // 页面返回
    pageGoBack(status = false) {
      this.isReq = false
      this.$refreshBack(status) // 关闭当前tab
    },
  },
}
</script>
<style lang="scss" scoped>
.app-main {
  overflow: hidden !important;
}
::v-deep .el-collapse-item__content {
  padding: 16px 14px;
}
.add-contract-temp {
  .temp_content {
    .temp_content_header {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      .form-box {
        flex: 1;
        ::v-deep .el-form-item {
          margin-bottom: 0;
        }
      }
    }
  }
  ::v-deep .w-e-text-container {
    height: calc(100vh - 340px) !important;
  }
  ::v-deep .w-e-full-screen-editor .w-e-text-container {
    height: calc(100vh - 42px) !important;
  }
}
.editor-container{
  display: flex;
  flex-direction: row;
  .edit{
    flex: 1;
  }
}
.editor-box {
  margin: 0 0 0 3px;
  border: 1px solid #ccc;
  width: 380px;
  height: 550px;
  overflow-y: auto;
  &-header {
    text-indent: 10px;
    line-height: 28px;
    font-size: 14px;
    color: #417de6;
    font-weight: 600;
    > span {
      color: red;
      font-size: 12px;
    }
  }
}
.check-item {
  padding: 0 0 3px 0px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  span {
    display: inline-block;
    font-size: 12px;
    line-height: 24px;
  }
  span:first-of-type {
    font-size: 14px;
    height: 24px;
    width: 200px;
  }
  span:last-of-type {
    flex: 1;
    text-align: left;
    word-wrap: break-word;
    word-break: break-all;
  }
  img{
    display: inline-block;
    width: 40%;
  }
  img:hover {
    transform:  translate(-60px) scale(2) ;
    transition: all 0.1s ease-in-out;
  }
}
</style>
